import { render, staticRenderFns } from "./perkawinan.vue?vue&type=template&id=4fffb35b&"
import script from "./perkawinan.vue?vue&type=script&lang=js&"
export * from "./perkawinan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports